/**
 * Beyond Subscription Name display names enums based on Docebo and Genesys Learning Subscriptions
 */
export enum SubscriptionName {
  AGENT_PLATFORM_SUBSCRIPTION = 'Agent Platform (AP) Training for Genesys Cloud',
  AGENT_PLATFORM_AP_ENGLISH = 'Agent Platform (AP) Training for Genesys Cloud - English',
  AGENT_PLATFORM_AP_SPANISH = 'Agent Platform (AP) Training for Genesys Cloud - Spanish',
  AGENT_PLATFORM_AP_PORTUGUESE = 'Agent Platform (AP) Training for Genesys Cloud- Portuguese',
  PARTNER_RESELL_AGENT_PLATFORM_AP_SUBSCRIPTION_ENGLISH = 'Partner Resell: Agent Platform (AP) Subscription',
  PARTNER_RESELL_AGENT_PLATFORM_AP_SUBSCRIPTION_SPANISH = 'Partner Resell: Agent Platform (AP) Subscription - Spanish',
  PARTNER_RESELL_AGENT_PLATFORM_AP_SUBSCRIPTION_PORTUGUESE = 'Partner Resell: Agent Platform (AP) Subscription - Portuguese',
  BEYOND_CX_SUBSCRIPTION = 'BeyondCX',
  GENESYS_CLOUD_SUBSCRIPTION = 'Genesys Cloud Learning Subscription',
  AI_ESSENTIAL_SUBSCRIPTION = 'AI Essentials Learning Subscription',
  LEGACY_GENESYS_CLOUD_PARTNER_DIGITAL_SUBSCRIPTION = 'Genesys Cloud CX Partner Digital Learning Subscription', // Docebo only external subscription link
  LEGACY_GENESYS_CLOUD_PARTNER_DIGITAL_PLUS = 'Genesys Cloud Partner CX Digital Plus', // Docebo only external subscription link
  GENESYS_CLOUD_PARTNER_DIGITAL_SUBSCRIPTION = 'Genesys Cloud Partner Digital Learning Subscription', // Docebo only external subscription link
  GENESYS_CLOUD_PARTNER_DIGITAL_PLUS_SUBSCRIPTION = 'Genesys Cloud Partner Digital Plus Learning Subscription', // Docebo only external subscription link
  LEGACY_GENESYS_CLOUD_PREMIER_PARTNER_SUBSCRIPTION = 'Genesys Cloud CX Premier Partner Learning Subscription',
  GENESYS_CLOUD_PREMIER_PARTNER_SUBSCRIPTION = 'Genesys Cloud Premier Partner Learning Subscription',
  GENESYS_CLOUD_TRIAL_SUBSCRIPTION = 'Genesys Cloud TRIAL Subscription',
  GENESYS_ENGAGE_SUBSCRIPTION = 'Genesys Engage on-premises Learning Subscription',
  GENESYS_ENGAGE_PARTNER_SUBSCRIPTION = 'Genesys Engage on-premises Partner Subscription',
  POINTILLIST_SUBSCRIPTION = 'Pointillist Learning Subscription',
  PURECONNECT_SUBSCRIPTION = 'PureConnect Learning Subscription',
  PURECONNECT_PARTNER_SUBSCRIPTION = 'PureConnect Partner Subscription',
}
